import { useQuery } from "@tanstack/react-query";
import { Space } from "antd";
import { Link } from "react-router-dom";
import { fetchRoles } from "../../../lib/api/resources/roles";
import { roleColumns } from "./lib/constants/roleColumns";
import { Table } from "@/components/v2";
import { Button } from "@rumbledirect/ui";
import { PlusOutlined } from "@ant-design/icons";

export const RolesList = () => {
  const rolesQuery = useQuery({
    queryKey: ["roles"],
    queryFn: fetchRoles,
  });

  return (
    <div>
      <Space
        style={{ marginBottom: 16, width: "100%", justifyContent: "flex-end" }}
      >
        <Link to="/roles/create">
          <Button icon={<PlusOutlined />}>Nieuwe rol</Button>
        </Link>
      </Space>
      <Table
        columns={roleColumns}
        dataSource={rolesQuery.data}
        rowKey="id"
        loading={rolesQuery.isFetching}
        pagination={false}
      />
    </div>
  );
};
